import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Grid,
  TextField,
  makeStyles,
  Container,
  Button,
  CardContent,
  Divider,
  InputLabel,
  CardHeader,
  MenuItem,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  Hidden,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import PageHeader from 'src/views/Common/PageHeader';
import { useAlert } from 'react-alert';
import { LoadingComponent } from '../../../utils/newLoader';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from '@material-ui/pickers';
import tokenDecoder from '../../../utils/tokenDecoder';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CountUp from 'react-countup';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecordAndNew: {
    backgroundColor: '#FFBE00'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

var screenCode = 'INVOICEPAYMENT';
export default function InvoicePaymentAddEdit(props) {
  const navigate = useNavigate();
  const alert = useAlert();
  const { referenceNumber } = useParams();
  const { groupID } = useParams();
  const { factoryID } = useParams();
  const [title, setTitle] = useState('Add Invoice Payment');
  const [isUpdate, setIsUpdate] = useState(false);
  const [isDisableButton, setIsDisableButton] = useState(false);
  const classes = useStyles();
  const [factories, setFactories] = useState();
  const [suppliers, setSuppliers] = useState();
  const [payVoucherCode, setPayVoucherCode] = useState();
  const [groups, setGroups] = useState();
  const [voucherTypes, setVoucherTypes] = useState([]);
  const [tranLedgerList, setTranLedgerList] = useState([]);
  const [tranLedgerListAuto, setTranLedgerListAuto] = useState([]);
  const [refNo, setRefNo] = useState("");
  const [voucherCode, setVoucherCode] = useState();
  const [selectedDate, handleDateChange] = useState(new Date());
  const [selectedDueDate, handleDueDateChange] = useState(new Date().toISOString());
  const [financialYearStartDate, setFinancialYearStartDate] = useState();
  const [journalData, setJournalData] = useState([]);
  const [journalDataCreditRecordUpdate, setJournalDataCreditRecordUpdate] = useState({});
  const [accountTypeNames, setAccountTypeNames] = useState();
  const [transactionModeCode, setTransactionModeCode] = useState();
  const [status, setStatus] = useState(0);
  const [dateDisable, setDateDisable] = useState(false);
  const [recordAndNewBtnEnable, setRecordAndNewBtnEnable] = useState(false);
  const [supplierCommon, setSupplierCommon] = useState(false);
  const [accountDescriptions, setAccountDescriptions] = useState({});
  const [ledgerAccountTRCodeFnl, setledgerAccountTRCodeFnl] = useState("");
  const [bankBranchCode, setBankBranchCode] = useState([]);
  const [ChequeNumberError, setChequeNumberError] = useState("");
  const location = useLocation();
  const { selectedRows, generalJournalList: generalJournalList } = location.state || {};
  const [generalJournalDetails, setGeneralJournalDetails] = useState({
    groupID: 0,
    factoryID: 0,
    supplierID: 0,
    payableModeID: '0',
    transactionTypeID: 0,
    statusID: 1,
    fromDate: new Date(),
    toDate: new Date(),
    transactionTypeID: '0',
    ledgerTransactionID: 0,
    referenceNumber: '',
    description: '',
    descriptionTypeID: 0,
    chequeNumber: '',
    isActive: true,
    preparedBy: '',
    updatedBy: '',
    voucherType: '0',
    voucherCode: '',
    transactionMode: '0',
    recipientName: '',
    address: '',
    tranLedgerAccountID: '0',
    ledgerAccountTRCode: '',
    modeoftransaction: '0',
    modeoftransactionNumber: '',
    payee: '',
    bankCode: '',
    branchCode: '',
    journalEntries: selectedRows || []
  });

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isApproveButtonEnabled: false
  });
  const [hasFocused, setHasFocused] = useState(false);
  const descriptionRef = useRef(null);

  useEffect(() => {

    if (descriptionRef.current && !hasFocused && generalJournalDetails.modeoftransaction !== 3) {
      descriptionRef.current.focus();
      setHasFocused(true);
    }

    if (
      descriptionRef.current &&
      (generalJournalDetails.modeoftransaction === 7) &&
      descriptionRef.current.value
    ) {
      descriptionRef.current.blur();
    }
  }, [generalJournalDetails, hasFocused]);

  const maxDate = new Date();
  const handleClick = () => {
    navigate('/app/invoicePayment/listing');
  };

  let decryptedfactoryID = 0;
  let decryptedgroupID = 0;
  useEffect(() => {
    getPermissions();
    getGroupsForDropdown();
    getPayVoucherCode();
  }, []);

  useEffect(() => {
    if (selectedRows && selectedRows.length > 0) {
      const rowData = selectedRows.map(row => ({
        debit: parseFloat(row.data.amount) || 0,
        amount: row.data.amount || 0,
        paidAmount: row.data.amount || 0,
        paymentStatus: row.data.paymentStatus || 2,
        invoiceDate: row.data.invoiceDate || '',
        invoiceNumber: row.invoiceNumber || '',
        invoiceReference: row.invoiceReference || '',
        estateName: row.data.estateName || '',
        factoryID: row.data.factoryID || 0,
        ledgerAccountName: row.data.ledgerAccountName || '',
        accountTypeName: row.data.ledgerAccountID || 0,
        payableModeName: row.data.payableModeName || '',
        supplierName: row.data.supplierName || '',
        description: row.description || '',
        descriptionTypeID: row.descriptionTypeID || 0,
        disableCreditField: false,
        disableDebitField: true,
        invoiceDetailID: row.data.invoiceDetailID || 0,
        rowID: GenerateRandomID(),

      }));
      setJournalData(rowData);

    } else {
      setJournalData([]);
    }
  }, [selectedRows]);

  useEffect(() => {
    if (generalJournalList) {
      setGeneralJournalDetails(prevDetails => ({
        ...prevDetails,
        ...generalJournalList
      }));
    }
  }, [generalJournalList]);

  useEffect(() => {
    if (generalJournalDetails.groupID !== '0') {
      trackPromise(getfactoriesForDropDown());
    }
  }, [generalJournalDetails.groupID]);

  useEffect(() => {
    if (generalJournalDetails.factoryID !== '0' && generalJournalDetails.modeoftransaction !== '0') {
      trackPromise(getTranLedgerList());
      trackPromise(getTranLedgerListAuto());
    }
  }, [generalJournalDetails.factoryID, generalJournalDetails.modeoftransaction]);

  useEffect(() => {
    decryptedgroupID = atob(groupID.toString());
    decryptedfactoryID = atob(factoryID.toString());    
    if (decryptedgroupID != 0) {
      trackPromise(
        getGeneralJournalDetails(
          decryptedgroupID,
          decryptedfactoryID
        )
      );
    } else {
      setJournalData([
        {
          accountTypeName: 0,
          invoiceNumber: '',
          credit: 0,
          debit: 0,
          description: '',
          descriptionTypeID: 0,
          ledgerTransactionID: 0,
          rowID: GenerateRandomID()
        }
      ]);
    }
  }, []);

  useEffect(() => {  
      trackPromise(getSuppliersForDropDown());
  }, [generalJournalDetails.factoryID, generalJournalDetails.groupID]);

  useEffect(() => {
    if (generalJournalDetails.tranLedgerAccountID.toString() !== '0' && tranLedgerListAuto.length > 0) {
      var listedone = tranLedgerListAuto.find(x => x.ledgerAccountID === parseInt(generalJournalDetails.tranLedgerAccountID));
      setledgerAccountTRCodeFnl(listedone === undefined || listedone === null ? "" : listedone.ledgerAccountTRCode);
    } else {
      setledgerAccountTRCodeFnl("");
    }
  }, [generalJournalDetails.tranLedgerAccountID, tranLedgerListAuto]);

  useEffect(() => {
    if (generalJournalDetails.factoryID) {
      setRefNo("");
    }
  }, [generalJournalDetails.factoryID]);

  useEffect(() => {
    if (
      payVoucherCode &&
      ledgerAccountTRCodeFnl !== "" &&
      generalJournalDetails.factoryID !== '0' &&
      generalJournalDetails.groupID !== 0 &&
      generalJournalDetails.tranLedgerAccountID !== '0'
    ) {
      trackPromise(getReferenceNumber());
    }
  }, [ledgerAccountTRCodeFnl, generalJournalDetails.tranLedgerAccountID, payVoucherCode, generalJournalDetails.factoryID, generalJournalDetails.groupID]);

  useEffect(() => {
    if (generalJournalDetails.factoryID !== '0') {
      trackPromise(GetBankBranchCode());
    }
  }, [generalJournalDetails.tranLedgerAccountID]);

  useEffect(() => {
    if (
      generalJournalDetails.modeoftransactionNumber > 0 &&
      bankBranchCode &&
      bankBranchCode.bankCode &&
      bankBranchCode.branchCode
    ) {
      getChequeNumberAvailable();
    }
  }, [generalJournalDetails.modeoftransactionNumber, bankBranchCode]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'ADDEDITINVOICEPAYMENT'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );
    var isApproveButtonEnabled = permissions.find(
      p => p.permissionCode == 'INVOICEPAYMENTAPPROVEBUTTONENABLED'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
      isApproveButtonEnabled: isApproveButtonEnabled !== undefined
    });

    setGeneralJournalDetails({
      ...generalJournalDetails,
      groupID: parseInt(generalJournalList.groupID),
      factoryID: parseInt(generalJournalList.factoryID),
      supplierID: parseInt(generalJournalList.supplierID),
      payableModeID: parseInt(generalJournalList.payableModeID),
    });
  }

  async function getReferenceNumber() {
    if (
      !generalJournalDetails.groupID ||
      !generalJournalDetails.factoryID ||
      !payVoucherCode ||
      !ledgerAccountTRCodeFnl
    ) {
      return;
    }
    let refModel = {
      groupID: generalJournalDetails.groupID,
      factoryID: generalJournalDetails.factoryID,
      date: selectedDate.toLocaleString().split('T')[0],
      voucherCode: payVoucherCode.voucherCode,
      ledgerAccountTRCode: ledgerAccountTRCodeFnl
    };
    const ref = await services.getReferenceNumber(refModel);
    setRefNo(ref.data);
  }

  async function GetBankBranchCode() {
    let BBModel = {
      groupID: parseInt(generalJournalDetails.groupID),
      factoryID: parseInt(generalJournalDetails.factoryID),
      ledgerAccountID: parseInt(generalJournalDetails.tranLedgerAccountID),
    };
    const BBCode = await services.GetBankBranchCode(BBModel);
    setBankBranchCode(BBCode.data);
  }

  async function getChequeNumberAvailable() {
    if (!bankBranchCode || !bankBranchCode.bankCode || !bankBranchCode.branchCode) {
      return;
    }
    var response = await services.getChequeNumberAvailable(generalJournalDetails.factoryID, bankBranchCode.bankCode, bankBranchCode.branchCode, generalJournalDetails.modeoftransactionNumber);
    if (response.data.length == 0) {
      setChequeNumberError("");
    }
    else {
      setChequeNumberError("Cheque Number Allready Exist!");
    }
  }

  async function getTranLedgerList() {
    const transaction = await services.getTranLedgerListForDropdown(
      generalJournalDetails.factoryID,
      generalJournalDetails.modeoftransaction
    );
    setTranLedgerList(transaction);
  }

  async function getTranLedgerListAuto() {
    const transaction = await services.getTranLedgerListForAutoDropdown(
      generalJournalDetails.factoryID,
      generalJournalDetails.modeoftransaction
    );
    setTranLedgerListAuto(transaction);
  }

  async function getAccountTypeNames(groupID, factoryID) {
    const accounts = await services.getLedgerAccountNamesForDatagrid(
      groupID,
      factoryID
    );
    setAccountTypeNames(accounts);
    return accounts;
  }

  async function getfactoriesForDropDown() {
    const factory = await services.getfactoriesForDropDown(
      generalJournalDetails.groupID
    );
    setFactories(factory);
  }

  async function getSuppliersForDropDown() {
    const supplierResult = await services.getSuppliersForDropDown(generalJournalDetails.groupID, generalJournalDetails.factoryID);
    setSuppliers(supplierResult);
  }

  async function getPayVoucherCode() {
    const payVoucherCodes = await services.getPayVoucherCode(
      generalJournalDetails.groupID
    );
    setPayVoucherCode(payVoucherCodes);
  }

  async function getGeneralJournalDetails(referenceNumber, groupID, factoryID) {
    let response = await services.getGeneralJournalDetailsByReferenceNumber(
      referenceNumber,
      groupID,
      factoryID
    );
    let data = response;
    setTitle('Update Payment');
    setGeneralJournalDetails({
      ...generalJournalDetails,
      groupID: data[0].groupID,
      factoryID: data[0].factoryID,
      ledgerTransactionID: data[0].ledgerTransactionID,
      transactionTypeID: data[0].transactionTypeID,
      referenceNumber: data[0].referenceNumber,
      description: data[0].description,
      descriptionTypeID: data[0].descriptionTypeID,
      recipientName: data[0].recipientName,
      transactionMode: data[0].transactionModeID,
      modeoftransaction: data[0].modeoftransactionID,
      modeoftransactionNumber: data[0].modeoftransactionNumber == null ? data[0].chequeNumber : data[0].modeoftransactionNumber,
      voucherType: data[0].voucherTypeID,
      payModeID: data[0].payModeID,
      chequeNumber: data[0].chequeNumber == null ? '' : data[0].chequeNumber,
      preparedBy: data[0].preparedBy,
      supplierID: data[0].supplierID,
      tranLedgerAccountID: data[0].tranLedgerAccountID,
      payee: data[0].payee,
      supplierID:data[0].supplierID
    });

    const supplierResult = await services.getSuppliersForDropDownAuto(
      data[0].groupID,
      data[0].factoryID
    );

    var foundCustomer = supplierResult.find(x => x.supplierID === data[0].supplierID);
    if (foundCustomer && foundCustomer.supplierCode == "COMMON") {
      setSupplierCommon(true)
    } else {
      setSupplierCommon(false)
    }
    setStatus(data[0].status);
    setRefNo(data[0].referenceNumber);
    handleDateChange(data[0].date)

    let copyArray = data;
    let tranLedgerAccountID = data[0].tranLedgerAccountID;
    let accountNameList = await getAccountTypeNames(data[0].groupID, data[0].factoryID);
    let tempArray = [...journalData]
    var filteredArray = copyArray.filter((x) => x.accountTypeName !== tranLedgerAccountID);
    var filteredCreditArray = copyArray.filter((x) => x.accountTypeName === tranLedgerAccountID);
    findCreditAccountTransactionUpdate(filteredCreditArray[0], accountNameList);
    filteredArray.forEach(element => {
      let reuslt = GetAll(element.accountTypeName, accountNameList);
      tempArray.push(
        {
          accountTypeName: element.accountTypeName,
          description: element.description,
          credit: element.credit,
          debit: element.debit,
          ledgerTransactionID: element.ledgerTransactionID,
          rowID: GenerateRandomID(),
          ledgerAccountCode: element.ledgerAccountCode,
          ledgerAccountName: element.ledgerAccountName,
          descriptionTypeID: element.descriptionTypeID,
          selected: reuslt
        }
      )
    });
    setJournalData(tempArray)
  }

  function findCreditAccountTransactionUpdate(filteredCreditArray, accountNameList) {
    let reuslt = GetAll(filteredCreditArray.accountTypeName, accountNameList);

    let model = {
      accountTypeName: filteredCreditArray.accountTypeName,
      description: filteredCreditArray.description,
      credit: filteredCreditArray.credit,
      debit: filteredCreditArray.debit,
      ledgerTransactionID: filteredCreditArray.ledgerTransactionID,
      rowID: 0,
      ledgerAccountCode: filteredCreditArray.ledgerAccountCode,
      ledgerAccountName: filteredCreditArray.ledgerAccountName,
      descriptionTypeID: filteredCreditArray.descriptionTypeID,
      tranLedgerAccountID: filteredCreditArray.tranLedgerAccountID,
      selected: reuslt
    }
    setJournalDataCreditRecordUpdate(model)
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  async function SaveGeneralJournal(isApproved) {
    if (journalData.some(row => parseFloat(row.debit) > parseFloat(row.amount))) {
      alert.error('Debit amount cannot be greater than the requested amount');
      return;
    }
    let newArray = []
    let index = journalData.findIndex(x => x.accountTypeName === 0);
    if (index >= 0) {
      alert.error('Account name is required, please check');
      if (index > 0) {
        journalData.splice(index, 1);
      }
      return;
    }

    var findZeroRecords = journalData.filter(x => parseFloat(x.debit) == 0)
    if (findZeroRecords.length !== 0) {
      alert.error('Amount Should be more than 0');
      return;
    }

    var sameBankAccount = journalData.filter(x => x.accountTypeName == generalJournalDetails.tranLedgerAccountID)
    if (sameBankAccount.length > 0) {
      alert.error('Same Debit and Credit Accounts Not Allowed');
      return;
    }
    if (!isUpdate) {
      let sumCredit = 0
      journalData.forEach(X => {
        sumCredit += parseFloat(X.debit)
      });

      // Create single credit entry for bank account
      let credit = {
        accountTypeName: generalJournalDetails.tranLedgerAccountID,
        credit: sumCredit,
        debit: 0,
        paidAmount: 0,
        amount: 0,
        paymentStatus: 0,
        factoryID: generalJournalDetails.factoryID,
        description: journalData[0].description,
        descriptionTypeID: journalData[0].descriptionTypeID,
        disableCreditField: false,
        disableDebitField: true,
        ledgerTransactionID: 0,
        invoiceDetailID: 0,
        rowID: journalData[0].rowID,
      }
      journalData.push(credit)

    } else {
      let sumCredit = 0
      journalData.forEach(X => {
        sumCredit += parseFloat(X.debit)
      });

      let credit = {
        accountTypeName: journalDataCreditRecordUpdate.tranLedgerAccountID,
        credit: sumCredit,
        debit: 0,
        factoryID: generalJournalDetails.factoryID,
        description: journalDataCreditRecordUpdate.description,
        descriptionTypeID: journalDataCreditRecordUpdate.descriptionTypeID,
        disableCreditField: false,
        disableDebitField: true,
        ledgerTransactionID: journalDataCreditRecordUpdate.ledgerTransactionID,
        rowID: journalDataCreditRecordUpdate.rowID,
      }
      journalData.push(credit)
    }

    newArray.push(journalData)

    index = journalData.findIndex(x => x.accountTypeName === 0);
    if (index >= 0) {
      alert.error('Account name is required, please check');
      journalData.splice(index, 1);
      return;
    }
    if (!isUpdate) {
      journalData.forEach(function (part, index) {
        journalData[index].accountTypeName = parseInt(part.accountTypeName);
        journalData[index].debit = parseFloat(part.debit);
        journalData[index].description = part.description;
        journalData[index].descriptionID = part.descriptionTypeID;
      });
      setJournalData(journalData)
    }
    var finalArray = journalData.filter(e => e.accountTypeName !== 0);
    if (!isUpdate) {
      if (!refNo || refNo === '') {
        alert.error('Reference number not generated. Please try again.');
        return;
      }
      let saveModel = {
        groupID: generalJournalDetails.groupID,
        factoryID: generalJournalDetails.factoryID,
        transactionTypeID: generalJournalDetails.transactionTypeID,
        referenceNumber: refNo,
        chequeNumber: generalJournalDetails.modeoftransaction == 3 ? generalJournalDetails.modeoftransactionNumber : '',
        voucherType: generalJournalDetails.voucherType,
        transactionMode: generalJournalDetails.transactionMode,
        voucherCode: voucherCode,
        recipientName: generalJournalDetails.recipientName,
        isActive: true,
        journalData: finalArray,
        date: selectedDate,
        dueDate: selectedDueDate,
        supplierID: generalJournalDetails.supplierID,
        tranLedgerAccountID: generalJournalDetails.tranLedgerAccountID,
        status: isApproved ? 2 : 1,
        reconsilationStatus: isApproved ? 1 : 0,
        modeoftransaction: generalJournalDetails.modeoftransaction,
        modeoftransactionNumber: generalJournalDetails.modeoftransaction == 7 ? generalJournalDetails.modeoftransactionNumber : '',
        payee: generalJournalDetails.payee,
        interEstateID: 0,
        isInterEstate: false,
        referenceNumberInter: ''
      };
      if (recordAndNewBtnEnable == true) {
        let response = await services.saveGeneralJournal(saveModel);

        if (response.statusCode == 'Success') {
          alert.success('Payment saved successfully');
          clearData();
          navigate('/app/invoicePayment/listing');
        } else {
          journalData.splice(index, 1);
          alert.error(response.message);
        }
      } else {
        let response = await services.saveGeneralJournal(saveModel);

        if (response.statusCode == 'Success') {
          alert.success('Payment saved successfully');
          clearData();
          navigate('/app/invoicePayment/listing');
        } else {
          journalData.splice(index, 1);
          alert.error(response.message);
        }
      }
    } else {
      let updateModel = {
        ledgerTransactionID: generalJournalDetails.ledgerTransactionID,
        groupID: generalJournalDetails.groupID,
        factoryID: generalJournalDetails.factoryID,
        transactionTypeID: generalJournalDetails.transactionTypeID,
        tranLedgerAccountID: generalJournalDetails.tranLedgerAccountID,
        referenceNumber: generalJournalDetails.referenceNumber,
        voucherType: generalJournalDetails.voucherType,
        transactionMode: generalJournalDetails.transactionMode,
        recipientName: generalJournalDetails.recipientName,
        chequeNumber: generalJournalDetails.chequeNumber,
        isActive: true,
        journalData: finalArray,
        date: selectedDate,
        dueDate: selectedDueDate,
        voucherCode: generalJournalDetails.voucherCode
      };
      let response = await services.updateGeneralJournal(updateModel);
      if (response.statusCode == 'Success') {
        alert.success('Payment updated successfully');
        clearData();
        navigate('/app/invoicePayment/listing');
      } else {
        journalData.splice(index, 1);
        alert.error(response.message);
      }
    }
  }

  function GetAll(ledgerAccountID, accountTypeNames) {
    const result = accountTypeNames.filter(
      a => a.ledgerAccountID.toString() === ledgerAccountID.toString()
    );
    return result;
  }

  function generateDropownForVoucherList(dataList) {
    let items = [];
    if (dataList != null) {
      voucherTypes.forEach(x => {
        if (x.screenCode == 'INVOICEPAYMENT') {
          items.push(
            <MenuItem key={x.voucherTypeID} value={x.voucherTypeID}>
              {x.voucherTypeName}
            </MenuItem>
          );
        }
      });
    }
    return items;
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function generateDropDownMenuWithTwoValues(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value.name}</MenuItem>);
      }
    }
    return items
  }

  function handleChangeForm(e) {
    const target = e.target;
    const value = target.value;
    setGeneralJournalDetails({
      ...generalJournalDetails,
      [e.target.name]: value
    });
  }

  function handleChangeSupplier(e) {
    const target = e.target;
    const value = target.value;
    setGeneralJournalDetails({
      ...generalJournalDetails,
      [e.target.name]: value
    });
    if ((value > 0) && (suppliers[value].code == 'COMMON')) {
      setSupplierCommon(true);
    } else {
      setSupplierCommon(false);
    }
  }

  function handleSearchDropdownChangeFields(data, e) {
    if (data === undefined || data === null) {
      setGeneralJournalDetails({
        ...generalJournalDetails,
        tranLedgerAccountID: '0'
      });
      return;
    } else {
      var valueV = data["ledgerAccountID"];
      setGeneralJournalDetails({
        ...generalJournalDetails,
        tranLedgerAccountID: valueV
      });
    }
  }

  function handleChangeForChequeNumber(e) {
    const target = e.target;
    let value = target.value;

    if (/^[0-9]*$/.test(value)) {
      setChequeNumberError("");
    }
    else {
      setChequeNumberError("Invalid input. Please enter a valid Cheque number.");
    }
  }

  const handleAmountChange1 = (e, index) => {
    const { value } = e.target;

    setJournalData((prevData) =>
      prevData.map((row, i) => {
        if (i === index) {
          const validNumber = /^(\d+(\.\d{0,2})?)?$/.test(value) ? value : row.debit;
          const paidaAmount = parseFloat(validNumber) || 0;
          const isDebitValid = paidaAmount <= row.amount && paidaAmount > 0;

          return {
            ...row,
            debit: validNumber,
            paymentStatus: paidaAmount === row.amount ? 2 : 3,
            validationError: isDebitValid ? null : "Enter a valid amount.",
          };
        }
        return row;
      })
    );
  };

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader onClick={handleClick} />
        </Grid>
      </Grid>
    );
  }

  function calDebitTotal() {
    let sumCredit = 0
    journalData.forEach(X => {
      sumCredit += parseFloat(X.debit)
    });
    return sumCredit.toFixed(2);
  }

  function findLoginUser() {
    return tokenDecoder.getUserNameFromToken();
  }

  function Cancel() {
    navigate('/app/invoicePayment/listing');
  }

  const RecordAndNew = async (validateForm, handleSubmit) => {
    setRecordAndNewBtnEnable(true);
    const errors = await validateForm();
    if (Object.keys(errors).length === 0) {
      trackPromise(SaveGeneralJournal(false));
    }
  };

  const ApproveClick = async (validateForm, handleSubmit) => {
    setRecordAndNewBtnEnable(false);

    const errors = await validateForm();
    if (Object.keys(errors).length === 0) {
      trackPromise(SaveGeneralJournal(true));
    }
  };

  function clearData() {
    setGeneralJournalDetails({
      ...generalJournalDetails,
      transactionTypeID: '0',
      referenceNumber: '',
      description: '',
      descriptionTypeID: 0,
      payModeID: '0',
      chequeNumber: '',
      isActive: true,
      preparedBy: '',
      updatedBy: '',
      voucherCode: '',
      transactionMode: '0',
      recipientName: '',
      tranLedgerAccountID: '0',
      supplierID: '0',
      bankCode: '',
      branchCode: '',
      supplierID:0
    });
    setJournalData([
      {
        accountTypeName: 0,
        credit: 0,
        debit: 0,
        description: '',
        descriptionTypeID: 0,
        ledgerTransactionID: 0,
        rowID: GenerateRandomID()
      }
    ]);
    handleDateChange(new Date());
    handleDueDateChange(new Date().toISOString());
    setRefNo('');
    setVoucherCode('');
  }

  async function handleSearchDropdownChange(e, data, rowID) {
    if (data === undefined || data === null) return;
    let valueV = data['ledgerAccountID'];


    const descriptions = await services.getAccountDescriptions(valueV);
    const newDesc = { ...accountDescriptions };
    delete newDesc[rowID];
    if (descriptions.length > 0) {
      newDesc[rowID] = descriptions;
    }
    setAccountDescriptions(newDesc);

    const newArr = [...journalData];
    var idx = newArr.findIndex(e => e.rowID == parseInt(rowID));
    if (idx !== -1) {
      let reuslt = GetAll(valueV, accountTypeNames);
      const existingRecords = newArr.filter(record => record.AccountTypeName == valueV);
      newArr[idx] = {
        ...newArr[idx],
        accountTypeName: parseInt(valueV),
        selected: reuslt,
        disableCreditField: existingRecords.length > 0 ? existingRecords[0].disableCreditField : false,
        disableDebitField: existingRecords.length > 0 ? existingRecords[0].disableDebitField : false,
        description: "",
        descriptionTypeID: 0
      };
    }
    setJournalData(newArr);
  }

  function changeText(e, rowID, inputType, IDvalue = 0, desc = null) {
    let target = e?.target ? e.target : '';
    let value = target !== '' ? target.value : '';
    const newArr = [...journalData];
    var idx = newArr.findIndex(e => e.rowID == parseInt(rowID));
    const AccountTypeName = newArr[idx].accountTypeName;
    if (inputType === "description") {
      newArr[idx] = { ...newArr[idx], description: value };
    }
    else if (inputType.includes('descriptionType')) {
      newArr[idx] = { ...newArr[idx], descriptionType: desc, descriptionTypeID: IDvalue };
    }
    else if (inputType === 'credit') {
      var reg = new RegExp('^[.0-9]*$');

      if (reg.test(value) == false) {
        alert.error('Allow Only Numbers');
        return;
      }

      let debitBool = false;
      let creditBool = false;
      if (parseFloat(value.toString()) > 0) {
        debitBool = true;
        creditBool = false;
      }
      if (value.toString().length > 18) {
        alert.error('Allow Only 18 Numbers');
        return;
      }

      newArr[idx] = {
        ...newArr[idx],
        credit: value === '' ? 0 : value,
        disableCreditField: creditBool,
        disableDebitField: debitBool
      };
    } else {
      var reg = new RegExp('^[.0-9]*$');

      if (reg.test(value) == false) {
        alert.error('Allow Only Numbers');
        return;
      }

      let debitBool = false;
      let creditBool = false;
      if (parseFloat(value.toString()) > 0) {
        debitBool = false;
        creditBool = true;
      }
      if (value.toString().length > 20) {
        alert.error('Allow Only 20 Numbers');
        return;
      }
      newArr[idx] = {
        ...newArr[idx],
        debit: IDvalue === '' ? 0 : IDvalue,
        disableCreditField: creditBool,
        disableDebitField: debitBool
      };
    }
    setJournalData(newArr);
  }

  function GenerateRandomID() {
    const d = new Date();
    let ms = d.valueOf();

    let rendomValue =
      ms + Math.floor(Math.random() * 10000) - 12 + (ms - 128 + ms * 512);
    return rendomValue;
  }
  function handleChangeForm(e) {
    const target = e.target;
    const value = target.value;
    if (e.target.name === 'modeoftransaction') {
      setGeneralJournalDetails({
        ...generalJournalDetails,
        [e.target.name]: value,
        tranLedgerAccountID: '0'
      });
    } else {
      setGeneralJournalDetails({
        ...generalJournalDetails,
        [e.target.name]: value
      });
    }
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: generalJournalDetails.groupID,
              factoryID: generalJournalDetails.factoryID,
              referenceNumber: referenceNumber,
              recipientName: generalJournalDetails.recipientName,
              description: generalJournalDetails.description,
              descriptionTypeID: generalJournalDetails.descriptionTypeID,
              voucherType: generalJournalDetails.voucherType,
              transactionMode: generalJournalDetails.transactionMode,
              chequeNumber: generalJournalDetails.chequeNumber,
              isActive: generalJournalDetails.isActive,
              isInterEstate: generalJournalDetails.isInterEstate,
              interEstateID: generalJournalDetails.interEstateID,
              tranLedgerAccountID: generalJournalDetails.tranLedgerAccountID,
              supplierID: generalJournalDetails.supplierID,
              modeoftransaction: generalJournalDetails.modeoftransaction,
              modeoftransactionNumber: generalJournalDetails.modeoftransactionNumber,
              payee: generalJournalDetails.payee,
              supplierCommon: supplierCommon
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number().required('Group required').min('1', 'Group required'),
              factoryID: Yup.number().required('Factory required').min('1', 'Factory required'),
              tranLedgerAccountID: Yup.number().required('Ledger Account is required').min('1', 'Ledger Account is required'),
              modeoftransaction: Yup.number().required('Mode of transaction required').min("1", 'Select Mode of transaction'),
              modeoftransactionNumber: Yup.string().when('modeoftransaction', {
                is: (modeoftransaction) => modeoftransaction == 3 && !isUpdate,
                then: Yup.string().required('Number is required').matches(/^\d+$/, 'Enter valid Number.').nullable()
              }),
              supplierID: Yup.number().when('payableModeID', {
                is: (payableModeID) => payableModeID === 1,
                then: Yup.number()
                  .required('Supplier required')
                  .min(1, 'Supplier required'),
                otherwise: Yup.number().nullable(),
              }),
              supplierCommon: Yup.bool(),
              payee: Yup.string().when('supplierCommon', {
                is: (supplierCommon) => supplierCommon == true && !isUpdate,
                then: Yup.string()
                  .required('Payee required'),
                otherwise: Yup.string().nullable(),
              }),
            })}
            validateOnChange={false}
            validateOnBlur={false}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched, values, validateForm }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => handleChangeForm(e)}
                              value={values.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={true}
                              InputProps={{
                                readOnly:
                                  isUpdate ||
                                    !permissionList.isGroupFilterEnabled
                                    ? true
                                    : false
                              }}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.factoryID && errors.factoryID
                              )}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => handleChangeForm(e)}
                              value={generalJournalDetails.factoryID}
                              disabled={true}
                              variant="outlined"
                              id="factoryID"
                              InputProps={{
                                readOnly:
                                  isUpdate ||
                                    !permissionList.isFactoryFilterEnabled
                                    ? true
                                    : false
                              }}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel
                              shrink
                              id="date"
                              style={{ marginBottom: '-8px' }}
                            >
                              Date *
                            </InputLabel>

                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                id="date-picker-inline"
                                value={selectedDate}
                                minDate={financialYearStartDate}
                                maxDate={maxDate}
                                disabled={dateDisable || isUpdate}
                                onChange={e => {
                                  handleDateChange(e);
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date'
                                }}
                                inputProps={{
                                  readOnly: true
                                }}
                                autoOk
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          {Hidden == true ? (
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="voucherType">
                                Voucher Type *
                              </InputLabel>
                              <TextField
                                select
                                error={Boolean(
                                  touched.voucherType && errors.voucherType
                                )}
                                fullWidth
                                helperText={
                                  touched.voucherType && errors.voucherType
                                }
                                name="voucherType"
                                size="small"
                                onBlur={handleBlur}
                                onChange={e => handleChangeForm(e)}
                                value={generalJournalDetails.voucherType}
                                variant="outlined"
                                id="voucherType"
                                disabled={isUpdate}
                                InputProps={{
                                  readOnly: isUpdate ? true : false
                                }}
                              >
                                <MenuItem value="0">
                                  --Select Voucher Type--
                                </MenuItem>
                                {generateDropownForVoucherList(voucherTypes)}
                              </TextField>
                            </Grid>
                          ) : null}
                          {isUpdate ?
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="tranLedgerAccountID">
                                Bank Account *
                              </InputLabel>
                              <TextField
                                select
                                error={Boolean(
                                  touched.tranLedgerAccountID &&
                                  errors.tranLedgerAccountID
                                )}
                                fullWidth
                                helperText={
                                  touched.tranLedgerAccountID &&
                                  errors.tranLedgerAccountID
                                }
                                name="tranLedgerAccountID"
                                size="small"
                                onBlur={handleBlur}
                                onChange={e => {
                                  handleChangeForm(e);
                                }}
                                value={generalJournalDetails.tranLedgerAccountID}
                                variant="outlined"
                                id="tranLedgerAccountID"
                                disabled={isUpdate}
                                InputProps={{
                                  readOnly: isUpdate ? true : false
                                }}
                              >
                                <MenuItem value="0">
                                  --Select Ledger Account--
                                </MenuItem>
                                {generateDropDownMenu(
                                  tranLedgerList
                                )}
                              </TextField>
                            </Grid>
                            : null}
                          {isUpdate ? <Grid item md={4} xs={12}>
                            <InputLabel shrink id="referenceNumber">
                              Voucher Code *
                            </InputLabel>
                            <TextField
                              error={Boolean(
                                touched.referenceNumber &&
                                errors.referenceNumber
                              )}
                              fullWidth
                              helperText={
                                touched.referenceNumber &&
                                errors.referenceNumber
                              }
                              name="referenceNumber"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => handleChangeForm(e)}
                              value={refNo}
                              variant="outlined"
                              InputProps={{
                                readOnly: true
                              }}
                              disabled={isUpdate}
                            />
                          </Grid> : null}
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="modeoftransaction">
                              Mode of transaction *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.modeoftransaction && errors.modeoftransaction)}
                              fullWidth
                              helperText={touched.modeoftransaction && errors.modeoftransaction}
                              name="modeoftransaction"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => { handleChangeForm(e); }}
                              value={generalJournalDetails.modeoftransaction}
                              variant="outlined"
                              id="modeoftransaction"
                              disabled={isUpdate}
                              InputProps={{
                                readOnly: isUpdate ? true : false
                              }}
                            >
                              <MenuItem value="0">--Select Transaction Mode--</MenuItem>
                              <MenuItem value="1"> Cash </MenuItem>
                              <MenuItem value="3"> Cheque </MenuItem>
                              <MenuItem value="7"> Fund Transfer </MenuItem>
                            </TextField>
                          </Grid>
                          {generalJournalDetails.modeoftransaction > 0 && generalJournalDetails.modeoftransaction !== 1 ?
                            <Grid item md={4} xs={12}>
                              {generalJournalDetails.modeoftransaction == 3 && generalJournalDetails.modeoftransaction !== 1 ?
                                <InputLabel shrink id="modeoftransactionNumber">
                                  Cheque Number *
                                </InputLabel>
                                :
                                <InputLabel shrink id="modeoftransactionNumber">
                                  Fund Transfer Number
                                </InputLabel>}
                              {generalJournalDetails.modeoftransaction == 3 && generalJournalDetails.modeoftransaction !== 1 ?
                                <TextField
                                  error={Boolean(touched.modeoftransactionNumber && errors.modeoftransactionNumber || Boolean(ChequeNumberError))}
                                  fullWidth
                                  helperText={touched.modeoftransactionNumber && errors.modeoftransactionNumber ? errors.modeoftransactionNumber : ChequeNumberError}
                                  name="modeoftransactionNumber"
                                  size="small"
                                  onBlur={handleBlur}
                                  onChange={e => {
                                    handleChangeForm(e);
                                    handleChangeForChequeNumber(e);
                                  }}
                                  inputProps={{
                                    maxLength: 6,
                                  }}
                                  value={generalJournalDetails.modeoftransactionNumber}
                                  disabled={isUpdate}
                                  variant="outlined"
                                /> : <TextField
                                  error={Boolean(touched.modeoftransactionNumber && errors.modeoftransactionNumber)}
                                  fullWidth
                                  helperText={touched.modeoftransactionNumber && errors.modeoftransactionNumber}
                                  name="modeoftransactionNumber"
                                  size="small"
                                  onBlur={handleBlur}
                                  onChange={e => {
                                    handleChangeForm(e);
                                    handleChangeForChequeNumber(e);
                                  }}
                                  value={generalJournalDetails.modeoftransactionNumber}
                                  disabled={isUpdate}
                                  variant="outlined"
                                />}
                            </Grid> : null}
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="tranLedgerAccountID">
                              Ledger Account *
                            </InputLabel>
                            <Autocomplete
                              id="tranLedgerAccountID"
                              options={tranLedgerListAuto}
                              getOptionLabel={(option) => option.ledgerAccountName != null ? option.ledgerAccountName.toString() : null}
                              onChange={(e, value) => handleSearchDropdownChangeFields(value, e)}
                              defaultValue={null}
                              renderInput={(params) =>
                                <TextField {...params}
                                  variant="outlined"
                                  name="tranLedgerAccountID"
                                  fullWidth
                                  size='small'
                                  placeholder='--Select Ledger Account--'
                                  value={generalJournalDetails.tranLedgerAccountID}
                                  helperText={touched.tranLedgerAccountID && errors.tranLedgerAccountID}
                                  onBlur={handleBlur}
                                  error={Boolean(touched.tranLedgerAccountID && errors.tranLedgerAccountID)}
                                />
                              }
                            />
                          </Grid>
                          {generalJournalDetails.modeoftransaction == 3 && (
                            <Grid item md={4} xs={12}>
                              <InputLabel
                                shrink
                                id="dueDate"
                                style={{ marginBottom: '-8px' }}
                              >
                                Due Date *
                              </InputLabel>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  fullWidth
                                  inputVariant="outlined"
                                  format="dd/MM/yyyy"
                                  margin="dense"
                                  id="due-date-picker"
                                  value={selectedDueDate}
                                  minDate={selectedDate}
                                  disabled={isUpdate}
                                  onChange={e => {
                                    handleDueDateChange(e);
                                  }}
                                  KeyboardButtonProps={{
                                    'aria-label': 'change due date'
                                  }}
                                  inputProps={{
                                    readOnly: true
                                  }}
                                  autoOk
                                />
                              </MuiPickersUtilsProvider>
                            </Grid>
                          )}
                          {generalJournalDetails.payableModeID == 1 ?
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="supplierID">
                                Supplier *
                              </InputLabel>
                              <TextField
                                select
                                error={Boolean(
                                  touched.supplierID && errors.supplierID
                                )}
                                fullWidth
                                helperText={touched.supplierID && errors.supplierID}
                                name="supplierID"
                                size="small"
                                onBlur={handleBlur}
                                onChange={e => handleChangeSupplier(e)}
                                value={generalJournalDetails.supplierID}
                                disabled={true}
                                variant="outlined"
                                id="supplierID"
                              >
                                <MenuItem value="0">--Select Supplier--</MenuItem>
                              {generateDropDownMenu(suppliers)}
                              </TextField>
                            </Grid>
                            : <Grid item md={4} xs={12}>
                              <InputLabel shrink id="supplierID">
                                Supplier
                              </InputLabel>
                              <TextField
                                select
                                error={Boolean(
                                  touched.supplierID && errors.supplierID
                                )}
                                fullWidth
                                helperText={touched.supplierID && errors.supplierID}
                                name="supplierID"
                                size="small"
                                onBlur={handleBlur}
                                onChange={e => handleChangeSupplier(e)}
                                value={generalJournalDetails.supplierID}
                                disabled={true}
                                variant="outlined"
                                id="supplierID"
                              >
                                <MenuItem value="0">--Select Supplier--</MenuItem>
                                {generateDropDownMenu(suppliers)}
                              </TextField>
                            </Grid>}
                          {supplierCommon ?
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="payee">
                                Payee *
                              </InputLabel>
                              <TextField
                                error={Boolean(
                                  touched.payee && errors.payee
                                )}
                                fullWidth
                                helperText={
                                  touched.payee && errors.payee
                                }
                                name="payee"
                                size="small"
                                onBlur={handleBlur}
                                onChange={e => handleChangeForm(e)}
                                value={generalJournalDetails.payee}
                                variant="outlined"
                                disabled={isDisableButton || isUpdate}
                                id="payee"
                              />
                            </Grid>
                            : null}
                        </Grid>
                        {transactionModeCode == 'CH' ? (
                          <Grid container spacing={3}>
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="chequeNumber">
                                Cheque Number
                              </InputLabel>
                              <TextField
                                error={Boolean(
                                  touched.chequeNumber && errors.chequeNumber
                                )}
                                fullWidth
                                helperText={
                                  touched.chequeNumber && errors.chequeNumber
                                }
                                name="chequeNumber"
                                size="small"
                                onBlur={handleBlur}
                                onChange={e => handleChangeForm(e)}
                                value={generalJournalDetails.chequeNumber}
                                variant="outlined"
                                disabled={isDisableButton}
                              />
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="recipientName">
                                Recipient Name
                              </InputLabel>
                              <TextField
                                error={Boolean(
                                  touched.recipientName && errors.recipientName
                                )}
                                fullWidth
                                helperText={
                                  touched.recipientName && errors.recipientName
                                }
                                name="recipientName"
                                size="small"
                                onBlur={handleBlur}
                                onChange={e => handleChangeForm(e)}
                                value={generalJournalDetails.recipientName}
                                variant="outlined"
                                disabled={isDisableButton}
                              />
                            </Grid>
                          </Grid>
                        ) : null}
                      </CardContent>
                      <CardContent height="auto">
                        <Box style={{ border: '1px solid gray' }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>Factory *</TableCell>
                                <TableCell>Account Name *</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Description Category</TableCell>
                                <TableCell>Amount *</TableCell>
                                <TableCell>Paid Amount *</TableCell>
                                <TableCell>Invoice NO</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {journalData && journalData.length > 0 ? (
                                journalData.map((row, index) => {
                                  const ID = row.rowID;
                                  return (
                                    <TableRow key={ID}>

                                      <TableCell>{row.estateName}</TableCell>
                                      <TableCell>{row.ledgerAccountName}</TableCell>
                                      <TableCell style={{ padding: "16px", width: "20%" }}>
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          placeholder="--Enter Description --"
                                          value={row.description || ""}
                                          onChange={(e) => changeText(e, ID, "description")}
                                          onBlur={(e) => {
                                            if (!e.target.value) {
                                              changeText({ target: { value: "" } }, ID, "description");
                                            }
                                          }}
                                          inputRef={descriptionRef}
                                          fullWidth
                                        />
                                      </TableCell>
                                      <TableCell style={{ padding: "16px", width: "15%" }}>
                                        <Autocomplete
                                          id={`descriptionType-${ID}`}
                                          options={accountDescriptions?.[ID] ?? []}
                                          size="small"
                                          disabled={!(accountDescriptions?.[ID] && accountDescriptions[ID].length > 0)}
                                          freeSolo={!accountDescriptions?.[ID]}
                                          getOptionLabel={(option) =>
                                            typeof option === 'string' ? option : option.accountDescription
                                          }
                                          onOpen={(e) => handleSearchDropdownChange(e, { ledgerAccountID: row.accountTypeName }, ID)}
                                          onChange={(e, value) => {
                                            if (value && value.accountDescriptionTypeID !== undefined) {
                                              changeText(e, ID, 'descriptionType', value.accountDescriptionTypeID, value.accountDescription);
                                            }
                                          }}
                                          clearOnBlur
                                          disableClearable={!accountDescriptions?.[ID]}
                                          value={
                                            accountDescriptions?.[ID]?.find(
                                              (desc) => desc.accountDescriptionTypeID === row.descriptionTypeID
                                            ) || null
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} fullWidth variant="outlined" placeholder="--Select Description Type--" />
                                          )}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          value={row.amount}
                                          onChange={(e) => handleAmountChange1(e, index)}
                                          fullWidth
                                          inputProps={{
                                            readOnly: true
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          value={row.debit}
                                          onChange={(e) => handleAmountChange1(e, index)}
                                          fullWidth
                                          type="number"
                                          error={!!row.validationError}
                                          helperText={row.validationError}
                                        />
                                      </TableCell>
                                      <TableCell>{row.invoiceNumber}</TableCell>
                                    </TableRow>
                                  );
                                })
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={5} align="center">
                                    No data available
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </Box>
                      </CardContent>
                      <CardContent>
                        <Box border={1} borderColor="#626964" >
                          <Table style={{ border: 'none', width: '100%' }}>
                            <TableBody>
                              <TableRow style={{ border: 'none' }}>
                                <TableCell style={{ borderBottom: 'none', width: '75%' }}>
                                  <InputLabel>
                                    <b>Prepared By </b>
                                    {isUpdate ? " : " + generalJournalDetails.preparedBy : ": " + findLoginUser()}
                                  </InputLabel>
                                </TableCell>
                                <TableCell style={{ borderBottom: 'none', width: '25%' }}>
                                  <InputLabel>
                                    <b><CountUp style={{ marginLeft: '13%' }} decimals={2} separator=',' end={calDebitTotal()} duration={0.1} /></b>
                                  </InputLabel>
                                </TableCell>
                              </TableRow>
                              {isUpdate ?
                                <TableRow style={{ border: 'none' }}>
                                  <TableCell style={{ borderBottom: 'none', width: '75%' }}>
                                    <InputLabel ><b>Updated By</b>{" : " + findLoginUser()}</InputLabel>
                                  </TableCell>
                                </TableRow>
                                : null}
                            </TableBody>
                          </Table>
                        </Box>
                      </CardContent>
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        <Button
                          color="primary"
                          id="btnCancel"
                          variant="contained"
                          style={{ marginRight: '1rem' }}
                          className={classes.colorCancel}
                          onClick={() => Cancel()}
                        >
                          Cancel
                        </Button>
                        {!isUpdate ? (
                          <Button
                            color="primary"
                            id="btnRecordAndNew"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecordAndNew}
                            onClick={() => RecordAndNew(validateForm, handleSubmit)}
                          >
                            Send to Approve
                          </Button>) : null}
                        {permissionList.isApproveButtonEnabled == true && !isUpdate ?
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={() => ApproveClick(validateForm, handleSubmit)}
                          >
                            Approve
                          </Button>
                          : null}
                        {isUpdate && status != 2 ? (
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                          >
                            Update
                          </Button>
                        ) : null}
                      </Box>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
